import { render, staticRenderFns } from "./publishGoodThingsAdd.vue?vue&type=template&id=2e3549b8&scoped=true"
import script from "./publishGoodThingsAdd.vue?vue&type=script&lang=js"
export * from "./publishGoodThingsAdd.vue?vue&type=script&lang=js"
import style0 from "./publishGoodThingsAdd.vue?vue&type=style&index=0&id=2e3549b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3549b8",
  null
  
)

export default component.exports